/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import {
  CustomCheckbox,
  TextInputComponent,
} from "../../../../../common/components";
import "./create-customer-address-details.scss";
import AddressFormFields from "../../../../../common/components/address-form-fields/address-form-fields";

const CreateCustomerAddressDetails = (props: any) => {

  // Sync Permanent address with Mailing address when checkbox is checked
    useEffect(() => {
      if (props.checked && props.values.mailingAddress) {
        props.setFieldValue("permanentAddress", props.values.mailingAddress);
      }
    }, [props.checked, props.values.mailingAddress, props.setFieldValue]);

  const handleBillingCheckBox = (isChecked: boolean) => {
    props?.setChecked(isChecked);

    const mailing = props.values?.mailingAddress;

    if (isChecked && mailing) {
      props.setFieldValue("permanentAddress", {
        streetLine1: mailing.streetLine1 || "",
        streetLine2: mailing.streetLine2 || "",
        city: mailing.city || "",
        state: mailing.state || "",
        country: mailing.country || "",
        zipcode: mailing.zipcode || "",
      });
    }
  };

  return (
    <div className="address-section-container">
      <div className="address-section">
        <div className="address-section-header">
          <h4>Mailing Address</h4>
        </div>
        <div className="create-lead-address-details address-section-body">
          <div>
            <AddressFormFields
              postCode="zipcode"
              namePrefix="mailingAddress"
            />
          </div>
        </div>
      </div>
      <div className="address-section">
        <div className="address-section-header">
          <h4>Permanent Address</h4>
          <div>
            <CustomCheckbox
              checked={props.checked}
              onChange={(checked: boolean) => handleBillingCheckBox(checked)}
              label="Same as Mailing Address"
            />
          </div>
        </div>
        <div className="create-lead-address-details address-section-body">
          <div>
            <AddressFormFields
              postCode="zipcode"
              namePrefix="permanentAddress"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCustomerAddressDetails;
